import React from "react";
import { Routes, Route } from "react-router-dom";
import Welcome from "../container/Login/WelcomePage/WelcomePage";
import Forgot from "../container/Login/forgotPassword";
import UnlockAccount from "../container/Login/UnlockAccount/UnlockAccount";


const UnAuthenticationRoutes = () => {
  return (
    <>
        <Routes>
          <Route path="*" element={<Welcome />} />
          <Route path="/" element={<Welcome />} />
          <Route exact path="/login" element={<Welcome />} />
          <Route path="/forgot-password" element={<Forgot /> } />
          <Route path="/unlock-account" element={<UnlockAccount />} />
        </Routes>
    </>
  );
};

export default UnAuthenticationRoutes;